import React from "react";
import FilterSection from "./components/FilterSection";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import AlertTable from "./components/AlertTable";
import CommandCard from "./components/CommandCard";
import DetailsCard from "./components/DetailsCard";
function DeviceConfig() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox display="flex">
        <MDBox maxWidth="40%"  sx={{width:"40%" , background:"#fff !important"}} p={2} m={2} borderRadius="lg" boxShadow="md" >
        <FilterSection />
        <CommandCard/>
        <DetailsCard/>
      </MDBox>
      <MDBox maxWidth="60%" sx={{width:"60%" , background:"#fff !important"}}  m={2} borderRadius="lg" boxShadow="md">
        <AlertTable/>
      </MDBox>
      </MDBox>
      
      
    </DashboardLayout>
  );
}

export default DeviceConfig;
